// @TODO - Currently not using this, but this could be handy for Entity multi select dropdown option
// manipulation
export default {
  data() {
    return {
      parsers: {
        report: (item) => this.parseReport(item),
      },
    };
  },
  methods: {
    parseReport(item) {
      let name = `#${item.id} - ${item.meeting_date}`;
      name += item.company != null ? ` - ${item.company.name}` : '';
      name += item.vip != null ? ` - ${item.vip.name}` : '';
      name += item.vip_description != null ? ` - ${item.vip_description}` : '';

      return {
        id: item.id,
        name: name,
      };
    },
  },
};
